import { useState } from 'react'
import { supabase } from '@/lib/supabase'

export function useImageUpload() {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  const uploadImage = async (file: File, folder: string = 'images'): Promise<string | null> => {
    if (!file) return null

    setUploading(true)
    setError('')

    try {
      // Generate unique filename
      const fileExt = file.name.split('.').pop()
      const fileName = `${Date.now()}-${Math.random().toString(36).substring(2)}.${fileExt}`
      const filePath = `${folder}/${fileName}`

      // Upload file to Supabase Storage
      const { data, error } = await supabase.storage
        .from('village-portal-images')
        .upload(filePath, file, {
          cacheControl: '3600',
          upsert: false
        })

      if (error) {
        throw error
      }

      // Get public URL
      const { data: urlData } = supabase.storage
        .from('village-portal-images')
        .getPublicUrl(filePath)

      return urlData.publicUrl
    } catch (err: any) {
      setError(err.message || 'Failed to upload image')
      return null
    } finally {
      setUploading(false)
    }
  }

  const deleteImage = async (imageUrl: string): Promise<boolean> => {
    try {
      // Extract file path from URL
      const url = new URL(imageUrl)
      const pathParts = url.pathname.split('/')
      const filePath = pathParts.slice(-2).join('/') // Get last two parts (folder/filename)

      const { error } = await supabase.storage
        .from('village-portal-images')
        .remove([filePath])

      if (error) {
        throw error
      }

      return true
    } catch (err: any) {
      setError(err.message || 'Failed to delete image')
      return false
    }
  }

  return {
    uploadImage,
    deleteImage,
    uploading,
    error
  }
}

